import { render } from "./loginAuth.vue?vue&type=template&id=3b1ae8d9"
import script from "./loginAuth.vue?vue&type=script&lang=js"
export * from "./loginAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__